import IconCircle from "./icon-circle";

export default IconCircle;
